import mixpanel from "mixpanel-browser";

// Records employee info on login
export const trackLogin = (query: any, agency: String) => {
  try {
    // Get data from person query
    const queryData = query.data.payload.data;
    const attributes = queryData.attributes;
    const id = queryData.id;
    const fullName = `${attributes["first-name"]} ${attributes["last-name"]}`;
    const email = attributes["email"];
    const phone = attributes["phone"];

    // Send information to Mixpanel
    mixpanel.identify(id);
    mixpanel.alias(fullName, id);
    mixpanel.track("Employee Login", {
      site: agency,
    });
    mixpanel.people.increment({
      "# of Logins": 1,
      "GOGOV Points": 1,
    });
    mixpanel.people.set_once("First Login", new Date());
    mixpanel.people.set({
      "$name": fullName,
      "$email": email,
      "$phone": phone,
      "Last Login": new Date(),
      "site": agency,
      "User Type": queryData.type,
      "Title": attributes["title"],
      "Department ID": attributes["department-id"],
      "Super Admin": attributes["super-admin"],
      "GORequest Role": attributes["crm-role"],
      "GOEnforce Role": attributes["ce-role"],
      "GOPermits Role": attributes["permits-role"],
    });

    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};

export const trackCitizenLogin = (
  user: { id: string; firstName: string; lastName: string; email: string; phone: string; isEmployee: boolean },
  agency: String,
) => {
  try {
    const { id, firstName, lastName, email, phone, isEmployee } = user;
    const fullName = firstName + " " + lastName;

    console.log({ user, agency });

    mixpanel.identify(id);
    mixpanel.alias(fullName, id);
    mixpanel.track("Citizen Portal Login", {
      site: agency,
    });
    mixpanel.people.set_once("First Login", new Date());
    mixpanel.people.set({
      "$name": fullName,
      "$email": email,
      "$phone": phone,
      "Last Login": new Date(),
      "site": agency,
      "User Type": isEmployee ? "Employee" : "Citizen",
    });
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};
